import { useUserInformations } from '../../hooks/WPHooks';
import { Modal } from '../globals/Modal';
import Identification from './Identification';

export const IdentificationModal = () => {
  const { user, isLoading } = useUserInformations();
  return (
    <Modal
      addClass="fullscreen-modal w-full h-full top-0 left-0 z-50 !mr-0"
      contentRender={(currentPath) => (
        <Identification
          user={user}
          slug={currentPath.split('/').pop() || 'identification'}
          isLoading={isLoading}
        />
      )}
      ModalUrl="/my-identity/"
      urlMatcher={(modalPath, currentPath) => currentPath.startsWith(modalPath)}
      backUrl=""
      hideCloseBtn={false}
    ></Modal>
  );
};
